/* Publish by EComposer at 2024-07-30 17:11:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nkdqvwt75p9"]=  window.__ectimmers["ecom-nkdqvwt75p9"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-nkdqvwt75p9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nkdqvwt75p9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9hes6wqkfr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9hes6wqkfr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g0y7x1xj144').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g0y7x1xj144', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmr2kx98zms').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmr2kx98zms', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3un6b64uqiu"]=  window.__ectimmers["ecom-3un6b64uqiu"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-3un6b64uqiu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3un6b64uqiu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9bncck9imh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9bncck9imh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}